import { Link, useLocation, useSearchParams } from "react-router-dom";
import MapView from "./MapView";
import type { ResearchedProduct } from "@/types/MarketResearch";
import { TypographyMuted } from "@/components/ui/typography";
import { 
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb' 

export type MarketResearchMapLocationState = {
  researchedProducts: ResearchedProduct[];
};

const MarketResearchMapPage = () => {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const searchId = searchParams.get("search");

  const researchedProducts = (state as MarketResearchMapLocationState | null)?.researchedProducts ?? [];

  return (
    <div className="flex flex-col h-full overflow-auto p-4 bg-gray-50">
      <Breadcrumb>
          <BreadcrumbList>
              <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                      <Link
                          className="hover:underline"
                          to="/market-research"
                      >
                          Planejamento de Pesquisa
                      </Link>
                  </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator /> 
              <BreadcrumbItem>
                  <BreadcrumbLink> 
                          Detalhes 
                  </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator /> 
              <BreadcrumbItem>
                  <BreadcrumbLink> 
                          Mapa 
                  </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator /> 
              <BreadcrumbItem>
                  <BreadcrumbPage>
                  {searchId && (
                      <Link
                        className=" inline-block font-medium text-primary underline"
                        to={`/market-research/details?search=${searchId}`}
                      >
                        Voltar aos detalhes
                      </Link>
                    )}
                  </BreadcrumbPage>
              </BreadcrumbItem>
          </BreadcrumbList>
      </Breadcrumb>
      {researchedProducts.length === 0 && (
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          <TypographyMuted className="text-amber-900">
            Nenhum dado de coleta recebido para o mapa. Abra o mapa pelo botão ao
            lado do ciclo na tela de detalhes da pesquisa.
          </TypographyMuted>
         
        </div>
      )}
      
      <MapView researchedProducts={researchedProducts} />
    </div>
  );
};

export default MarketResearchMapPage;
